var OrderRow = require('./OrderRow').OrderRow;
import { AbconetApi } from '../General/AbconetApi';
import $ from "jquery";


export class OrderSummary extends React.Component {

    constructor(props) {
        super(props);  
        this.state = {
            orderList: props.initialState
        }
    }

    componentDidMount() {
        $(document).on('CartUpdated', this.updateData.bind(this));
    }

    updateData() {
        AbconetApi.get('/api/order?itemsPerPage=3').then(orderList => {
            this.setState({ orderList: orderList.list });
        });
    }

    renderRows(row, hidePrices) {
        var id = row.salesOrderId;
        if (id == null) {
            id = row.cartId;
        }

        return <OrderRow order={row} key={`order-${id}`} hidePrices={hidePrices} />;
    }
    
    render() {
        return <div className="list-group">
                   <div className="row header">
                       <div className="col-6 col-hd">
                           <div className="order-header">Orders</div>
                       </div>
                       <div className="col-3 col-hd">
                           Items
                       </div>
                       <div className="col-3 col-hd">
                           <div className="total-header">Total</div>
                       </div>
                   </div>

                {this.state.orderList.map(x => this.renderRows(x, this.props.hidePrices))}
               </div>;
    }

}